import { FC, useRef } from "react";
import {
  NavigationMenuProps
} from "Types";
import { useEcomConfig } from "hooks";

import NavigationButton from "Templates/Template4/Components/Navbar/NavigationButton";
import DropdownMenu from "Templates/Template4/Components/Navbar/DropdownMenu";
import ScrollButtons from "Templates/Template4/Components/Navbar/ScrollButtons";

const NavigationMenu: FC<NavigationMenuProps> = (props) => {
  const categoryBtnRef = useRef<HTMLButtonElement>(null);
  const recordsBtnRef = useRef<HTMLButtonElement>(null);
  const authorBtnRef = useRef<HTMLButtonElement>(null);
  const languageBtnRef = useRef<HTMLButtonElement>(null);
  const academicBtnRef = useRef<HTMLButtonElement>(null);
  const merchandiseBtnRef = useRef<HTMLButtonElement>(null);

  const {
    showAuthor: showAuthors,
    showLanguage,
    showAcademic,
    showMerchandise,
    showOffers,
    showEvents,
    showGlossary,
    showHistory,
  } = useEcomConfig();

  const getDropdownValue = () => {
    if (!props.activeMenu) return null;

    switch (props.activeMenu) {
      case "category":
        return "Category";
      case "records":
        return "Record";
      case "author":
        return "Author";
      case "language":
        return "Language";
      case "academic":
        return "Academic";
      case "merchandise":
        return "Merchandise";
      default:
        return null;
    }
  };

  return (
    <div
      ref={props.dropdownRef}
      className="relative hidden md:flex md:sticky md:top-0 z-50 bg-vintageBg shadow-md"
    >
      <div
        ref={props.scrollRef}
        className="flex gap-6 px-20 lg:px-24 xl:px-28 items-center py-3 overflow-x-auto no-scrollbar"
      >
        <NavigationButton
          ref={categoryBtnRef}
          label="Category"
          isActive={props.activeMenu === "category"}
          onClick={() => props.handleNavigation("/category")}
          onMouseEnter={() => {
            props.handleMenuEnter("category");
            requestAnimationFrame(() =>
              props.updateDropdownPosition(categoryBtnRef.current),
            );
          }}
        />


        {showAuthors && (
          <NavigationButton
            ref={authorBtnRef}
            label="Author"
            isActive={props.activeMenu === "author"}
            onClick={() => props.handleNavigation("/authors")}
            onMouseEnter={() => {
              props.handleMenuEnter("author");
              requestAnimationFrame(() =>
                props.updateDropdownPosition(authorBtnRef.current),
              );
            }}
          />
        )}

        {showLanguage && (
          <NavigationButton
            ref={languageBtnRef}
            label="Language"
            isActive={props.activeMenu === "language"}
            onClick={() => props.handleNavigation("/language")}
            onMouseEnter={() => {
              props.handleMenuEnter("language");
              requestAnimationFrame(() =>
                props.updateDropdownPosition(languageBtnRef.current),
              );
            }}
          />
        )}

        {showAcademic && (
          <NavigationButton
            ref={academicBtnRef}
            label="Academic"
            isActive={props.activeMenu === "academic"}
            onClick={() => props.handleNavigation("/academic")}
            onMouseEnter={() => {
              props.handleMenuEnter("academic");
              requestAnimationFrame(() =>
                props.updateDropdownPosition(academicBtnRef.current),
              );
            }}
          />
        )}

        <NavigationLink
          to="/new-collections"
          label="New Arrival"
          onNavigation={props.handleNavigation}
        />

        <NavigationLink
          to="/top-sellers?page=1"
          label="Bestsellers"
          onNavigation={props.handleNavigation}
        />

        {showMerchandise && (
          <NavigationButton
            ref={merchandiseBtnRef}
            label="Merchandise"
            isActive={props.activeMenu === "merchandise"}
            onClick={() => props.handleNavigation("/merchandise")}
            onMouseEnter={() => {
              props.handleMenuEnter("merchandise");
              requestAnimationFrame(() =>
                props.updateDropdownPosition(merchandiseBtnRef.current),
              );
            }}
          />
        )}

        <NavigationButton
          ref={recordsBtnRef}
          label="Record"
          isActive={props.activeMenu === "records"}
          onClick={() => props.handleNavigation("/product-listing?productType=UkVDT1JE")}
          onMouseEnter={() => {
            props.handleMenuEnter("records");
            requestAnimationFrame(() =>
              props.updateDropdownPosition(recordsBtnRef.current),
            );
          }}
        />

        {/* {showOffers && (
          <NavigationLink
            to="/offers"
            label="Offers"
            onNavigation={props.handleNavigation}
          />
        )} */}

        {showEvents && (
          <NavigationLink
            to="/events"
            label="Events"
            onNavigation={props.handleNavigation}
          />
        )}

        {showGlossary && (
          <NavigationLink
            to="/gallery"
            label="Gallery"
            onNavigation={props.handleNavigation}
          />
        )}

        {showHistory && (
          <NavigationLink
            to="/history"
            label="History"
            onNavigation={props.handleNavigation}
          />
        )}
      </div>

      <DropdownMenu
        activeDropdown={getDropdownValue()}
        dropdownLeft={props.dropdownLeft}
        mappedCategories={props.mappedCategories}
        mappedRecordCategories={props.mappedRecordCategories}
        hoveredCategory={props.activeCategory}
        authors={props.authors}
        languages={props.languages}
        academics={props.academics}
        merchandises={props.merchandises}
        isLoading={props.isLoading}
        error={props.error}
        onHoverCategory={props.setHoveredCategory}
        onClose={props.handleMenuLeave}
      />

      <ScrollButtons
        showLeft={props.showLeft}
        showRight={props.showRight}
        onScroll={props.scroll}
      />
    </div>
  );
};

const NavigationLink: FC<{
  to: string;
  label: string;
  onNavigation: (path: string) => void;
}> = ({ to, label, onNavigation }) => (
  <div className="whitespace-nowrap">
    <button
      onClick={() => onNavigation(to)}
      className="text-sm lg:text-base text-gray-800 font-gilroyRegular font-semibold tracking-wider px-3 py-2 hover:bg-vintageText hover:bg-opacity-80 hover:text-vintageBg transition-all rounded-full"
    >
      {label}
    </button>
  </div>
);

export default NavigationMenu;
